<div
  class="btn-group"
  ngbDropdown
  role="group"
  aria-label="Export product dropdown"
>
  <button
    type="button"
    class="btn btn-outline-primary btn-sm mr-2"
    ngbDropdownToggle
  >
    Export to
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button
      *ngFor="let item of items"
      (click)="item.onClick()"
      type="button"
      class="btn btn-outline-primary btn-sm"
      ngbDropdownItem
    >
      {{ item.label }}
    </button>
  </div>
</div>
